import reactRpc from '@square/react-rpc-client';
import { ConsoleLoggerFactory } from '@square/react-rpc-client/utils';
import { RpcError } from 'rpc/model/Error';
import { getEnvironment, Env } from 'typescript/utilities/environment';

const loggingEnabled = getEnvironment() !== Env.PRODUCTION;

const rpc = () => {
  return reactRpc({
    loggerFactory: new ConsoleLoggerFactory(loggingEnabled),
    errorDeserializer: RpcError.fromResponse,
  });
};

export default rpc;
